import { useState } from 'react';
import { TodoItem } from './TodoItem';

export function TodoList({
    todos,
    onDelete,
    onDeleteCompleted,
    onComplete,
    onReopen,
}) {
    const [showActive, setShowActive] = useState(true);
    const [showCompleted, setShowCompleted] = useState(true);
    const handleShowAll = () => {
        setShowActive(true);
        setShowCompleted(true);
    };
    const handleShowCompleted = () => {
        setShowActive(false);
        setShowCompleted(true);
    };
    const handleShowActive = () => {
        setShowActive(true);
        setShowCompleted(false);
    };

    return (
        <div className="m-8 shadow-md">
            <ul className="divide-gray-200 divide-y">
                {todos.filter(({completed}) => completed ? showCompleted : showActive).map((todo) => (
                    <TodoItem
                        {...todo}
                        onDelete={onDelete}
                        onComplete={onComplete}
                        onReopen={onReopen}
                    />
                ))}
            </ul>

            <div className="bg-light-bg-primary items-center justify-between m-4 md:flex p-2 rounded-b-md">
                <span className="text-light-text-primary text-xs"><span role="counter">{todos.length}</span> items</span>

                <div className="space-x-2">
                    <button type="button" className="font-bold text-light-text-primary text-xs" onClick={handleShowAll}>All</button>
                    <button type="button" className="font-bold text-light-text-primary text-xs" onClick={handleShowActive}>Active</button>
                    <button type="button" className="font-bold text-light-text-primary text-xs" onClick={handleShowCompleted}>Completed</button>
                </div>

                <button type="button" className="text-light-text-primary text-xs" onClick={onDeleteCompleted}>Clear Completed</button>
            </div>
        </div>
    );
}
